// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6a7ea1d5","239":"dfdb0d71","396":"8cafcfcc","453":"d855a71b","455":"ec63873d","977":"b5623f9a"}[chunkId] + ".chunk.js";
};